import React, { Fragment } from "react";
import PropTypes from "prop-types";

import useGet from "../../hooks/useGet";
import Loading from "../Loading";
import Result from "./Result";

const Results = ({ url, params, manuallySubmitted }) => {
  const [loading, response, error] = useGet(url, {
    params: params
  });

  return (
    <Fragment>
      {/* Only show the loading indicator if the user manually submits the form */}
      {manuallySubmitted && loading && (
        <div className="QuickSearch-results noHeader">
          <Loading className="Loading--small" label="Searching..." />
        </div>
      )}

      {response && response.data.out[0].mItems.length !== 0 && (
        <div className="QuickSearch-results noHeader">
          <ol className="f-scale-body">
            {response.data.out[0].mItems.map((result, i) => (
              <Result key={i} result={result} />
            ))}
          </ol>
        </div>
      )}

      {/* Only show the no results message if the user manually submits the form */}
      {manuallySubmitted &&
        response &&
        response.data.out[0].mItems.length === 0 && (
          <div className="QuickSearch-results noHeader">
            <ol className="f-scale-body">
              <li className="QuickSearch-results-item">No Results</li>
            </ol>
          </div>
        )}

      {error && (
        <div className="QuickSearch-results noHeader">
          <ol className="f-scale-body">
            <li className="QuickSearch-results-item">{error.message}</li>
          </ol>
        </div>
      )}
    </Fragment>
  );
};

Results.propTypes = {
  url: PropTypes.string.isRequired,
  params: PropTypes.object,
  manuallySubmitted: PropTypes.bool.isRequired
};

export default Results;
